module.exports = __webpack_public_path__ + "dcce53e516afb2f572daeb4745a25fe5.svg";